import React from 'react';
import { useNavigate, useParams } from 'react-router-dom'; 

import { IconDots, IconEdit, IconSitemap, IconTrash } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../../components/mantine/menu";
import { ActionIcon, rem } from '@mantine/core';

const ActionMenu = (props: any) => {
    const { item, open, OpendeletePopUp, SetSelectedRows } = props
    const navigate = useNavigate();
    const handleViewSites = () => {
        const clientId = item?.id;
        //router.push(`/managesites?clientId=${clientId}`);
        navigate(`/managesites/${clientId}`);
    };
    return (
        <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
            <MantineMenuTarget>
                <ActionIcon variant="subtle" color="gray">
                    <IconDots style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                </ActionIcon>
            </MantineMenuTarget>
            <MantineMenuDropdown>
                <MantineMenuItem
                    leftSection={<IconEdit style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { open(); SetSelectedRows(item); }}
                >
                    Edit
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { OpendeletePopUp(); SetSelectedRows(item); }}
                >
                    Delete
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconSitemap style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { handleViewSites(); SetSelectedRows(item) }}
                >
                    View Sites
                </MantineMenuItem>
            </MantineMenuDropdown>
        </MantineMenu>
    );
};
export default ActionMenu;
